import React from "react";
import RecruiterOrdersTableHeader from "./RecruiterOrdersTableHeader";
import RecruiterOrdersPageTable from "./RecruiterOrdersPageTable";
import RecruiterLayerBlueprint from "components/blueprints/RecruiterLayerBlueprint";

function RecruiterOrdersPage() {
  return (
    <section className="bg-gray-100" style={{ minHeight: "calc(100vh - 60px)" }}>
      <div className="container mx-auto">
        <div className="bg-white pt-2 pb-6 shadow-md blur-2 text-opacity-15 spread-0 mb-[30px]">
          <RecruiterOrdersTableHeader />
          <RecruiterOrdersPageTable />
        </div>
      </div>
    </section>
  );
}

export default RecruiterLayerBlueprint(RecruiterOrdersPage);
